import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppUtilityService {

  constructor() { }

  //return min and max length of mobile number base on the country code selected
  mobileNumberMinMaxLength(countryCode){
    var maxLength = 11
    var minLength = 1
    //for MY max and min length should be 11 numeric characters
    if(countryCode == '60'){
      maxLength = 10
      minLength = 9
    }else if (countryCode == '65') {
      maxLength = 8
      minLength = 8
    }else{
      //hard coded 50 as this is the max length sibs can handle
      maxLength = 50 - countryCode.length
    }
    return {max: maxLength, min: minLength}
  }

  mobileNumberValidation(mobileNumber){
   var regExp = /^\d+$/;
   const testExp = regExp.test(mobileNumber)
   return testExp
  }

  alphaNumeric(inputKey){
    var regExp =  /^[a-zA-Z0-9]$/
    const testExp = regExp.test(inputKey)
    return testExp
  }

  alphaNumericWithBaseSymbols(inputKey){
    var regExp =  /^((?!_)[\w\'\ .,/-\s])+$/
    const testExp = regExp.test(inputKey)
    return testExp
  }

  characterValidation(inputKey){
    var regExp = /[A-Za-z0-9 ~!@#$%^&*()_+`\-\=|\[\]\\:”’\'\"?\,./]/g
    const testExp = regExp.test(inputKey)
    return testExp;
  }

  filterInvalidCharacters(string){
    return string.replace(/[^A-Za-z0-9 ~!@#$%^&*()_+`\-\=|\[\]\\:”’\'\"?\,./]/g,"");
  }

  stringValidation(string){
    var regExp = /^[A-Za-z0-9 ~!@#$%^&*()_+`\-\=|\[\]\\:”’\'\"?\,./]*$/g
    const testExp = regExp.test(string)
    return testExp;
  }

  numericOnlyValidation(inputKey){
    var regExp = /[0-9]/g
    const testExp = regExp.test(inputKey)
    return testExp;

  }

  mobileNumberPattern(countryCode){
    if (countryCode == '60'){
     // original regex
     // return "^(1)[0-46-9]-*[0-9]{7,8}$"
     return "^(1)[0-9]{8,9}$"
    } else if (countryCode == '65') {
      return "^(8|9)[0-9]{7}$"
    } else{
      return "^[0-9]*$"
    }
  }

  nricValidation(nric) {
    let regExp = /^[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[0-9]{6,9}$/
    let testExp = regExp.test(nric);
    if (testExp) {
      let year = parseInt(nric.substring(0, 2));
      let month = parseInt(nric.substring(2, 4));
      let day = parseInt(nric.substring(4, 6));
      if ((month === 4 || month === 6 || month === 9 || month == 11)) {
        return day <= 30 ? true : false;
      } else if (month === 2) {
        if (year % 4 == 0) {
          return day <= 29 ? true : false;
        } else {
          return day <= 28 ? true : false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
